export const ICONS = {
    equaliserAnimatedGreen: '../images/icon/equaliser-animated-green.gif',
    google: '../images/logo/google.png',
    lang_en: '../images/logo/en.png',
    lang_vi: '../images/logo/vi.png',
    loading: '../images/icon/loading.svg',
};